import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutContainerComponent } from './layout/layout-container/layout-container.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { MatchingModule } from './matching/matching.module';
import { AppInterceptor } from './shared/interceptors/app.interceptor';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SettingsModule } from './settings/settings.module';
import { OrganizationModule } from './organization/organization.module';
import { UsersModule } from './users/users.module';
import { SettingsLayoutComponent } from './layout/settings-layout/settings-layout.component';
import { TopBannerComponent } from './layout/top-banner/top-banner.component';
import { ImportMatchingModule } from './import-matching/import-matching.module';


@NgModule({
  declarations: [
    AppComponent,NavbarComponent,
    LayoutContainerComponent,
    SettingsLayoutComponent,
    TopBannerComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    AppRoutingModule,
    ButtonModule,
    AppRoutingModule,
    MatchingModule,
    BrowserModule,
    BrowserAnimationsModule,
    SettingsModule,
    UsersModule,
    OrganizationModule,
    ImportMatchingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
